<template>

  <div>
    <div class="bold-text" v-if="displayLabel">
      {{ label }}
    </div>
    <div>
      {{getValue(property)}}
    </div>
  </div>

</template>

<script>

export default {

  name: 'ShowBooleanField',

  props: {
    object: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    property: {
      type: String,
      default: null
    },
    displayLabel: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    getValue () {
      return property => this.object? ((this.object[property] || this.object[property] === false) ? (this.object[property]? this.$t('Yes'): this.$t('No')) : '-'): '-'
    }
  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b122/showFields/ShowBooleanField.vue